module.exports = __webpack_public_path__ + "img/only-bg_blocks.73768378.svg";